import { Box } from "@mui/material";
import { PrimaryTooltip } from "../StyledComponent";
import CircleInfoIcon from "./CircleInfoIcon";

const InfoIconTooltip = ({ title, maxWidth = 260, placement = "top" }) => (
  <PrimaryTooltip
    title={title}
    placement={placement}
    componentsProps={{ tooltip: { sx: { maxWidth } } }}
  >
    <Box sx={{ display: "flex", alignItems: "center", cursor: "default" }}>
      <CircleInfoIcon sx={{ width: 14, height: 14 }} />
    </Box>
  </PrimaryTooltip>
);

export default InfoIconTooltip;
